import { render, staticRenderFns } from "./AboutPageDataSource.vue?vue&type=template&id=64a552d5&scoped=true"
import script from "./AboutPageDataSource.vue?vue&type=script&lang=js"
export * from "./AboutPageDataSource.vue?vue&type=script&lang=js"
import style0 from "./AboutPageDataSource.vue?vue&type=style&index=0&id=64a552d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a552d5",
  null
  
)

export default component.exports